
import Vue from 'vue';
import { CqlQueryBuilderOptions } from '@/components/cql/cql-types';
export default Vue.extend({
	props: {
		options: Object as () => CqlQueryBuilderOptions
	},
	methods: {
		onClick(op: string) {
			this.$emit('click', op);
		}
	}
})
